module.exports = __webpack_public_path__ + "static/media/background-career-2.940022fd.svg";